import React from "react";
import '../styles/components/Footer.css';

function Footer()
{
    return(
        <div className="footer">
            <div className="content">
                <div className="contact">
                    <p>Andrea Brunori Music</p>
                    <p>Email: <a href="mailto:info@kefrenproductions.com">info@kefrenproductions.com</a></p>
                </div>

                <div className="links">
                    <p>
                        <a href="/Homepage">HomePage</a> <a href="/About">About</a> <a href="/Contact">Contact</a> <br></br><br></br>
                        <a href="https://open.spotify.com/intl-it/artist/1EwVwRAxMwa468Lxfl4Gbx?si=KKvTLmvuSnCqztyXt0E_ng" target="_blank">Spotify</a> <br></br>
                        <a href="https://www.youtube.com/@andreabrunori" target="_blank">Youtube</a> <br></br>
                        <a href="https://andreabrunori.bandcamp.com/album/about-love-death-and-despair" target="_blank">BandCamp</a> <br></br>
                        
                    </p>
                </div>
            </div>  
        </div>

    )
}

export default Footer;